import { InspectorsGridView } from '~/components/customers/inspectors';
import { PageContainer } from '~/components/page-container';

export function Inspectors() {
	return (
		<PageContainer>
			<InspectorsGridView />
		</PageContainer>
	);
}
